import React from 'react';
import './SegmentedControl.css';
import Icon from '../home/Icon';

// Segment-Schalter: genau eine Auswahl aus wenigen gleichrangigen Optionen.
// options: [{ value, label, icon?, tone? }]
//   tone färbt das aktive Segment: 'positive' | 'warning' | 'accent' | 'negative' | 'neutral' (default)
//   → passend zu den Outcome-Farben (bestätigt = grün, Warteliste = gelb, Zusatz-Warteliste = blau)
//   bzw. zur Typ-Farbe (Privat = rot, wie das Schloss-Icon privater Spieltage).
// size: 'md' (default) | 'sm'
// Buttons haben type="button", damit sie innerhalb von Popup-Formularen nicht submitten.
function SegmentedControl({ options, value, onChange, ariaLabel, size = 'md' }) {
  return (
    <div className={`segmentedControl ${size}`} role="group" aria-label={ariaLabel}>
      {options.map(opt => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            aria-pressed={active}
            className={`segmentedControlOption ${opt.tone ?? 'neutral'}${active ? ' active' : ''}`}
            onClick={() => { if (!active) onChange(opt.value); }}
          >
            {opt.icon && <Icon className={"segmentedControlIcon"} icon={opt.icon} />}
            <span className={"segmentedControlLabel"}>{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
}

export default SegmentedControl;
